import { render, staticRenderFns } from "./ModuleSchemes.vue?vue&type=template&id=38b6b016&scoped=true"
import script from "./ModuleSchemes.vue?vue&type=script&lang=js"
export * from "./ModuleSchemes.vue?vue&type=script&lang=js"
import style0 from "./ModuleSchemes.vue?vue&type=style&index=0&id=38b6b016&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b6b016",
  null
  
)

export default component.exports